"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface QuoteBannerCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
  note: string;
}
const copyData: Record<Lang, QuoteBannerCopy> = {
  en: {
    eyebrow: "Wedge Wire Screen Specifications",
    heading: "Need Custom Wedge Wire Screen Specifications?",
    lead: "Submit your slot opening (0.02 to 5.0 mm), surface wire profile, support rod spacing, and alloy grade. Our engineers review parameters and provide technical quotes for your vessel.",
    secondaryLabel: "Contact Our Engineers",
    note: "Continuous slot openings from 0.02 to 5.0 mm with precision resistance welding"
  },
  zh: {
    eyebrow: "楔形丝筛网技术规格",
    heading: "需要定制楔形丝筛网规格与工程方案？",
    lead: "提交您的缝隙开孔（0.02 至 5.0 mm）、表面型丝截面、支撑筋间距及合金材质需求。我们的工程团队为您审核参数并提供技术报价。",
    secondaryLabel: "咨询技术工程师",
    note: "全电阻熔焊连续缝隙开孔 0.02 至 5.0 mm"
  },
  es: {
    eyebrow: "Especificaciones de mallas de alambre en cuña",
    heading: "¿Necesita especificaciones personalizadas de alambre en cuña?",
    lead: "Envíe su abertura de ranura (0,02 a 5,0 mm), perfil de alambre, espaciado de varillas de soporte y aleación. Nuestros ingenieros revisan los parámetros y cotizan.",
    secondaryLabel: "Contactar con ingenieros",
    note: "Aberturas continuas de ranura de 0,02 a 5,0 mm con soldadura por resistencia de precisión"
  },
  de: {
    eyebrow: "Spaltsieb-Spezifikationen",
    heading: "Benötigen Sie kundenspezifische Spaltsieb-Spezifikationen?",
    lead: "Übermitteln Sie Ihre Spaltweite (0,02 bis 5,0 mm), Drahtprofil, Tragstababstand und Legierung. Unsere Ingenieure prüfen die Daten und erstellen Ihr Angebot.",
    secondaryLabel: "Ingenieure kontaktieren",
    note: "Kontinuierliche Spaltweiten von 0,02 bis 5,0 mm mit präziser Widerstandsschweißung"
  },
  fr: {
    eyebrow: "Spécifications des grilles à fil profilé",
    heading: "Besoin de spécifications sur mesure pour grille en fil profilé ?",
    lead: "Transmettez votre ouverture de fente (0,02 à 5,0 mm), profil de fil, espacement des supports et alliage. Nos ingénieurs analysent vos paramètres et émettent un devis.",
    secondaryLabel: "Consulter nos ingénieurs",
    note: "Fentes continues de 0,02 à 5,0 mm avec soudure par résistance de haute précision"
  },
  pt: {
    eyebrow: "Especificações de telas tipo cunha",
    heading: "Precisa de especificações personalizadas para telas de arame em cunha?",
    lead: "Envie sua abertura de fenda (0,02 a 5,0 mm), perfil de arame, espaçamento de hastes e liga metálica. Nossos engenheiros avaliam os parâmetros e apresentam a proposta.",
    secondaryLabel: "Falar com engenheiros",
    note: "Aberturas contínuas de 0,02 a 5,0 mm com solda por resistência de precisão"
  }
};
export default function QuoteBanner() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="quotectabanner" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage"
  }} note={content.note} />;
}